import React from 'react';
import PropTypes from 'prop-types';
import application_contants from '../../contants/application_contants';

// TODO: replace these with your actual icon imports
// import DbIcon    from './assets/db.svg'
// import PdfIcon   from './assets/pdf.svg'
// import FaqIcon   from './assets/faq.svg'
// import BookIcon  from './assets/book.svg'
// import GlobeIcon from './assets/globe.svg'

export default function Resources({ section_id }) {
  const items = [
    { icon: application_contants.IconSize,    title: 'SYSPIN Dataset',      link: 'https://spiredatasets.ee.iisc.ac.in/syspincorpus' },
    { icon: application_contants.IconSize,    title: 'SPICOR English Dataset',      link: 'https://spiredatasets.ee.iisc.ac.in/englishttscorpus' },
    { icon: application_contants.IconSize,   title: 'SPICOR Gujarati Dataset',      link: 'https://spiredatasets.ee.iisc.ac.in/gujaratittscorpus' },
    // { icon: application_contants.FAQicon,   title: 'FAQ Document',        link: '/assets/faq.pdf' },
    // { icon: application_contants.ReferenceIcon,  title: 'Reference Page',      link: 'https://drive.google.com/file/d/16Mzmc3VvNJsY7oWtt5_M9m7OM3eC4ORc/view?usp=sharing' },
    { icon: application_contants.DocIcon, title: 'API Documentation',   link: 'https://drive.google.com/file/d/1XaSsnSPLtNtMs9m9CTW8k2HTwYS7Pq3y/view?usp=drive_link' }
  ]

  return (
    <section id={section_id} className="resources-section">
      {/* <p className="res-subtitle title-navy-blue">For Your Need</p> */}
      <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Resources</h2>

      <div className="res-grid">
        {items.map(item => (
          <div key={item.title} className="res-card">
            <div className="res-icon">
              <img src={item.icon} alt="" />
            </div>
            <h3 className="res-name jostRegular h3-small section-title title-dark">{item.title}</h3>
            <a href={item.link} className="res-download title-navy-blue jostRegular h6-small" target='_blank' rel="noreferrer">
              Download&nbsp;<span className="arrow">→</span>
            </a>
          </div>
        ))}
      </div>

      <div className="res-callout section-title jostRegular h1-medium">
        Models must be built using SYSPIN / SPICOR + optionally open-source datasets
      </div>
<br></br>
      <div className="participate-cta">
        <div className="avatars">
          <img src={application_contants.avatar1} alt="Avatar 1" />
          <img src={application_contants.avatar2} alt="Avatar 2" />
          <img src={application_contants.avatar3} alt="Avatar 3" />
        </div>
        <h3 className="h2-medium section-title title-navy-blue pb-2 title">Still have questions?</h3>
        <p className="jostRegular h5-small section-title title-dark-grey">Can’t find the answer you’re looking for? Please mail us.</p>
        {/* <a href="/contact" className="btn-contact jostRegular h5-small">Get in touch</a>
        <a href="/contact" className="btn-contact jostRegular h5-small">Get in touch</a> */}
        <p className="jostRegular h5-small section-title title-dark-grey">
          <a href="mailto:challenge.syspin@gmail.com">challenge.syspin@gmail.com</a>
          <br></br>
          <a href="mailto:challenge.syspin@iisc.ac.in">challenge.syspin@iisc.ac.in</a>

        </p>
      </div>
    </section>
  )
}

Resources.propTypes = {
  section_id: PropTypes.string.isRequired
}
